import { DropShadowMediumCloseStyle, DropShadowMediumCloseStyleAndroid, DropShadowMediumDistantStyle } from '../../config/designSystem/Shadow';
import { SPACING } from '../../config/designSystem/Spacing';
import { StyleProp, View, ViewStyle } from 'react-native';
import { isAndroid } from '../../config/designSystem/Layout';

// boxShadow follows the view's OWN border radius, so a square wrapper casts a square
// shadow even when the card inside it is rounded -- the corners poke out past the
// rounding. Most cards this wraps use the sp-12 design-system radius, so default to it
// and let the rest declare their own shape through `radius`.
const CARD_RADIUS = SPACING['sp-12'];

// A number rounds all four corners; the object form is for cards that round only some
// of them (a bottom sheet rounds its top edge and leaves the bottom square). Passing
// the object REPLACES the default outright, so an unlisted corner stays square and the
// shadow keeps matching the card.
type Corners = Pick<ViewStyle,
  'borderRadius'
  | 'borderTopLeftRadius' | 'borderTopRightRadius'
  | 'borderBottomLeftRadius' | 'borderBottomRightRadius'>;

type DropShadowMediumProps = {
  children: React.ReactNode;
  style? : StyleProp<ViewStyle>;
  radius?: number | Corners;
}

export const DropShadowMedium = ({children, style, radius}: DropShadowMediumProps)  => {
  const corners: Corners = typeof radius === 'number'
    ? { borderRadius: radius }
    : radius ?? { borderRadius: CARD_RADIUS };

  if(isAndroid) {
    return(
      <View style={[{ width:'100%'}, corners, DropShadowMediumCloseStyleAndroid, !!style && style]}>
        {children}
      </View>
    );
  }
  return(
    <View  style={[{ width: '100%'}, corners,  DropShadowMediumCloseStyle, !!style && style]}>
      <View style={[{ width:'100%'}, corners, DropShadowMediumDistantStyle, !!style && style]}>
        {children}
      </View>
    </View>
  );
};
